var default_styles_default = {
  "button_container": "RnL3p",
  "button_margin": "XPVlT",
  "button_text": "_0aQRh",
  "button_size_content": "hS278"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
